import React from 'react';
import { COLORS } from '../QuestionChartConfig';

const PointsLegend = ({ question }) => {
  const results = question.results || [];
  const total = results.reduce((sum, item) => sum + Number(item.value), 0);

  return (
    <div className="survey-result-details-list">
      {results.map((item, idx) => {
        const pct = total > 0 ? ((Number(item.value) / total) * 100).toFixed(1) : '0.0';
        const itemColor = COLORS[idx % COLORS.length];

        return (
          <div key={item.id || item.name} className="details-list-row">
            <div className="details-list-left">
              <span className="survey-result-color-dot" style={{ backgroundColor: itemColor }} />
              <span className="details-list-name">{item.name}</span>
            </div>
            <div className="details-list-right">
              <div className="details-list-pct" style={{ color: '#2d3748', fontWeight: 'bold' }}>
                {pct}%
              </div>
              <div className="details-list-count">
                {item.value} {item.value === 1 ? 'pt' : 'pts'}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default PointsLegend;
